export interface BookingOfferLookup {
  id: number;
  name: string;
  companyId?: number;
}

interface OfferLookupShape {
  id: number;
  name: string;
  companyId?: number | null;
}

export const mapOfferToBookingOfferLookup = (
  offer: OfferLookupShape | undefined | null
): BookingOfferLookup | undefined => {
  if (!offer) {
    return undefined;
  }

  const companyId =
    typeof offer.companyId === 'number' && Number.isInteger(offer.companyId) && offer.companyId > 0
      ? offer.companyId
      : undefined;

  return {
    id: offer.id,
    name: offer.name,
    companyId,
  };
};
